module.exports = __webpack_public_path__ + "img/bidWinActive.21b57bf5.png";